



















import { Vue, Component, Prop } from 'vue-property-decorator'
import { LoginUser } from '@/types/user'

@Component({
  components: {
    VideoCallIncomingContainer: () =>
      import(
        '@/components/common/videoCallRoom/VideoCallIncomingContainer.vue'
      ),
    VideoCallContainer: () =>
      import('@/components/common/videoCallRoom/VideoCallContainer.vue'),
    VideoCallRoom: () => import('./VideoCallRoom.vue')
  }
})
export default class VideoCall extends Vue {
  @Prop(Object) user!: LoginUser
}
